const EmploymentTypes = ["Full Time", "Part Time", "Temporary", "Internship"];

export default EmploymentTypes;
